export default __webpack_public_path__ + "static/media/promos-icon.c176a434.webp";